export default "__VITE_ASSET__l$AtR7cv__"